import ApiClient from '@/libs/http-client'
import NotificationsService from '@/services/api/notifications.services'



const state = {
    allNotifications: []
}

const mutations = {
    SET_ALL_NOTIFICATIONS(state, payload) {
        state.allNotifications = payload
    }
}

const actions = {

    getPins() {
      return new Promise((resolve, reject) => {
          ApiClient.get('api/pins')
              .then((response) => {
                  return resolve(response)
              })
              .catch((error) => reject(error))
      })
  },

  addPin(_context, { name, url }) {
    return ApiClient.post('api/pins', { name, url })
  },

  delPin(_context, { id }) {
    return ApiClient.delete(`api/pins/${id}`)
  },
  

    getAllNotifications({ commit }) {
        return new Promise((resolve, reject) => {
            NotificationsService.get('getNotifications')
                .then((response) => {
                    commit('SET_ALL_NOTIFICATIONS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    checkNotification(context, payload) {
        return new Promise((resolve, reject) => {
            NotificationsService.checkNotification(payload.id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    checkAllNotifications() {
        return new Promise((resolve, reject) => {
            NotificationsService.checkAllNotifications()
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    deleteNotification(context, id) {
        return new Promise((resolve, reject) => {
            NotificationsService.delete('deleteNotification', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    deleteAllNotifications() {
        return new Promise((resolve, reject) => {
            NotificationsService.delete('deleteAllNotifications')
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getAllNotifications: state => state.allNotifications
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
